import { useTheme } from '@emotion/react'
import { Container, Grid } from '@mui/material'
import React, { useState } from 'react'
import { Heading, P, SectionSmallHeading, SectionSubHeading, SectionWrapper } from '../../../Styles/style'
import { SocialImage, SocialLinks, SocialMedia } from '../S6_Faq/styles'

import Twitter from "../../../../assets/images/wtwitter.png"
import Telegram from "../../../../assets/images/wtelegram.png"
import styled from '@emotion/styled'
const BuyNow = styled.a`
text-decoration: none;
background-color: ${(props) => (props.bgColor ? props.bgColor : props.theme.textSecondary)};
color: ${(props) => (props.Color ? props.Color : props.theme.textPrimary)};
padding: 12px 20px;
border-radius: 5px;
display: flex;
max-width: 160px;
align-items: center;

`
const Div = styled.div`
text-align-last: center;

`
const Section9_Footer = () => {

    const theme = useTheme()
    return (
        <>
            {/* <SectionWrapper p="8rem 0" align="left" >

            </SectionWrapper> */}
            <Container maxWidth="xl">
                <div >
                <Div style={{}}>
                        <a href="https://t.me/pulseshibportal" target="blank">
                            <img src={Telegram} />
                        </a>
                        &nbsp;
                        &nbsp;
                        &nbsp;
                        <a href="https://twitter.com/pulseshib_token" target="blank">
                            <img src={Twitter} />
                        </a>
                    </Div>
                    <P align="center" m="0" p="10px 0">© 2023 PulseOTC. All Rights Reserved.</P>
                   
                </div>
            </Container>
        </>
    )
}

export default Section9_Footer